export default {
  setNotAccomplishNum(state, data) {

    state.notAccomplishNum = data
  },
  setSecretary(state, data = {}) {
    if (data.name) state.secretaryName = data.name
    if (data.phone) state.secretaryPhone = data.phone
  },
}